module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js